export const GRID_PAGE_SIZE_OPTIONS = [25, 50, 100, 500, 1000]
